module.exports = __webpack_public_path__ + "img/13.5894bc41.jpg";